/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-uploader.vue?vue&type=template&id=4264b962&"
import script from "./batch-uploader.vue?vue&type=script&lang=js&"
export * from "./batch-uploader.vue?vue&type=script&lang=js&"
import style0 from "./batch-uploader.vue?vue&type=style&index=0&id=4264b962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports